import { ReactNode, FC } from "react";
// import config from "../../../config";

import Button from "../../../components/Mobile/Button";

// var webUrl = config?.webUrl;

const FoodHow = () => {
  return (
    <section className="relative z-0 h-[1170px] mb-[48px]">
      <div className="relative w-full h-full">
        {/* First Row */}
        <div
          className="h-[174px] bg-primaryDark-400 scroll-mt-[90px] pt-[40px]"
          id="food-how"
        >
          <h4 className="text-[24px] text-text-1000 text-center font-raleway font-bold ">
            How Does It Work?
          </h4>
        </div>

        {/* Second Row */}
        <div className="bg-text-1000 border border-[#E9E9E9] rounded-[16px] absolute z-[2] top-[120px] right-[20px] left-[20px] px-[25px] py-[20px]">
          {/* Cards */}
          <div className="grid grid-cols-1 gap-[24px] mb-[24px]">
            {/* Card One */}
            <FoodHowCard
              step={1}
              heading={<>Complete Your Profile</>}
              description={
                <>
                  Open an account on the{" "}
                  <span className="text-primaryDark-400 font-bold leading-loose">
                    {" "}
                    Resource Pantry{" "}
                  </span>{" "}
                  and complete your profile.
                </>
              }
            />

            {/* Card Two */}
            <FoodHowCard
              step={2}
              heading={
                <>
                  Get Matched to Listings
                </>
              }
              description={
                <>Explore options in the area that fit your criteria.</>
              }
            />

            {/* Card Three */}
            <FoodHowCard
              step={3}
              heading={<>Request Culinary Resource</>}
              description={<>Reserve your slot or request more information.</>}
            />

            {/* Card Four */}
            <FoodHowCard
              step={4}
              heading={<>Get Cooking!</>}
              description={
                <>
                  Now you can focus on developing mouthwatering recipes instead
                  of logistics.
                </>
              }
            />
          </div>

          {/* Button */}
          <div className="scroll-mt-[100px]" id="food-how-box">
            <Button
              label="Watch Tutorials"
              variant="secondary"
              onClick={() => window.open("https://site.homecookapp.com/resource-pantry-step-categories", "_blank")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

type FoodHowCardProps = {
  step: number;
  heading: ReactNode;
  description: ReactNode;
};

const FoodHowCard: FC<FoodHowCardProps> = ({ step, heading, description }) => {
  return (
    <div className="border-[2px] border-dashed border-[#E9E9E9] rounded-[16px] p-[20px]">
      {/* Header */}
      <div className="flex items-center gap-[16px] mb-[16px]">
        <p className="text-[80px] font-raleway text-[#F5F5F5] leading-none">
          {step}
        </p>
        <h5 className="text-[20px] font-raleway font-semibold text-primaryDark-0 leading-tight">
          {heading}
        </h5>
      </div>

      <p className="text-[16px] font-open-sans text-text-0 leading-loose">
        {description}
      </p>
    </div>
  );
};

export default FoodHow;
